export const MARKET_DETAIL_SLUGS = [
  'equities',
  'etfs',
  'forex',
  'indices',
  'commodities',
];

export const isMarketDetailPage = (pageSlug) =>
  MARKET_DETAIL_SLUGS.includes(pageSlug);
